module.exports = __webpack_public_path__ + "img/inflatableBlue.4bded4db.svg";